import React from "react";
import { HeaderFilters } from "@shared/types";

export const PageWrapperFiltersContext = React.createContext<{
  filters: HeaderFilters | undefined;
  setFilters: (filters: HeaderFilters | undefined) => void;
}>({
  filters: undefined,
  setFilters: () => undefined,
});
